import { useEffect, useState } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { SideBar } from '../SideBar';

import styles from './styles.module.scss';
import { MenuButton } from '../MenuButton';

export const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    useEffect(() => {
        if (window.innerWidth < 768) {
            setSidebarOpen(false);
        }
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setSidebarOpen(true);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={styles.page}>
            <ScrollRestoration />
            <MenuButton 
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />

            {sidebarOpen && <SideBar setSidebarOpen={setSidebarOpen}/>}
            <div className={styles.content}>
                <Header />
                <main className={styles.main}>
                    <div className={styles.mainInner}>
                        <Outlet />
                    </div>
                </main>
                <Footer />
            </div>
        </div>
    );
};